export default __webpack_public_path__ + "static/media/1030_1032_nåtade_teakbord_kompass_rek.0e5af328.jpg";